import { isAxiosError } from 'axios';
import { axiosWrapper } from '../../FetchData/axiosWrapper';

export const makePostRequest = async <TResponseData, TRequestPayload = object>(
    url: string,
    payload: TRequestPayload
): Promise<Success<TResponseData> | ClientError | ServerError | RequestError | UndefinedError> => {
    try {
        const result = await axiosWrapper.post<TResponseData>(url, payload);

        return {
            state: 'Success',
            data: result.data,
        };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                if (error.response.status.toString().startsWith('4')) {
                    return {
                        code: error.response.status,
                        state: 'ClientError',
                        message: error.response.data?.message || error.message,
                    };
                }

                if (error.response.status.toString().startsWith('5')) {
                    return {
                        code: error.response.status,
                        state: 'ServerError',
                    };
                }
            } else if (error.request) {
                return {
                    code: error.request.status,
                    state: 'RequestError',
                };
            }
        }

        return {
            state: 'UndefinedError',
        };
    }
};

export type ResultStatus = SuccessState | ClientErrorState | ServerErrorState | RequestErrorState | UndefinedState;

interface Success<T> {
    state: SuccessState;
    data: T;
}

interface HttpError<Type> {
    code: number;
    state: Type;
}

export type RequestError = HttpError<RequestErrorState>;
export type ServerError = HttpError<ServerErrorState>;
export type UndefinedError = Pick<HttpError<UndefinedState>, 'state'>;
export type ClientError = HttpError<ClientErrorState> & { message?: string };

type SuccessState = 'Success';
type ClientErrorState = 'ClientError';
type RequestErrorState = 'RequestError';
type ServerErrorState = 'ServerError';
type UndefinedState = 'UndefinedError';
